import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { campaigns, products, brands } from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";
import Delete from "components/Buttons/Delete";
import Price from "components/Formaters/Price";
import Number from "components/Formaters/Number";
import Percent from "components/Formaters/Percent";
import ChartBookingContacts from "components/Charts/ChartBookingContacts";
import ChartBookingROI from "components/Charts/ChartBookingROI";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";
import * as os from "osutil";

import Field from "components/Form/Field";

class Report extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/rapporter");
  }

  test = () => {
    //dispatch(showLoading())
  };

  componentWillMount() {
    this.props.actions.fetchBrands();
    this.props.actions.fetchProducts();
    this.props.actions.fetchCampaigns(this.props.user.accountid);
  }

  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(this.props.campaign.details, ...data);
    this.props.actions.updateCampaign(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
  }

  handleRemove = (bookingid, booking) => {
    if (this.props.campaign.details.transactionId) {
      return;
    }
    this.props.actions.removeFromCampaign(
      this.props.user.accountid,
      this.props.params.id,
      bookingid
    );
  };

  handleSendBooking = () => {

    if (this.props.campaign.details.transactionId) {
      return;
    }

    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    data.status = "booked";
    let merged = Object.assign(this.props.campaign.details, ...data);
    merged.status = "booked";
    this.props.actions.updateCampaign(
      this.props.user.accountid,
      this.props.params.id,
      merged
    );
    this.setState({open: false});
    
  };

  renderEditions = (list, product) => {
    return _.map(list, (e, key) => {
      var pe = product.editions[key];
      if (pe) {
        return (
          <span key={key} className="campaign_item_editions_item">
            {pe.number}
          </span>
        );
      }
    });
  };

  renderBookings = () => {
    
    var data = _.reduce(this.props.campaign.bookings, (result, b, key) => {
      var p = this.props.products[b.productid];
      if (p) {
        var brand = this.props.brands[p.brandid];
        if (brand && b.bruttocontacts > 0) {
          if (!result[brand.name])
          {
            result.bars[brand.name] = 0;
          }
          result.bars[brand.name] += parseInt(b.bruttocontacts);
          result.total += parseInt(b.bruttocontacts);
          result.cost += parseInt(b.amount);
          console.log(b);
        }
      }
      return result;
    }, {cost: 0, total: 0, bars: {}});

    var revenue = parseInt(this.props.campaign.details.revenue)
    var cost = parseInt(data.cost)
    var roi = 0;
    if (revenue && cost)
    {
      roi = Math.floor(100 * (revenue - cost) / cost);
    }

  return (
    <PageSection label={this.props.campaign.details.name}>
    <Row key="Bruttokontakter">
        <b>Bruttokontakter: <Number value={data.total} /> individer</b>
      </Row>,
      <Row key="chart">
        <ChartBookingContacts item={data.bars} /> 
      </Row>,
      <Row key="roi">
      { roi ? <b>Avkastning på investering/ROI: <Percent value={""+roi} /></b> : null }
      </Row>,
      <Row key="roi_chart">
        { roi ? <ChartBookingROI item={{"Intäkter": revenue, "Kostnader": cost, }} /> : null }
      </Row>,
    </PageSection> 
    )
  };


  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };


  render() {
    if (
      !this.props.campaign ||
      !this.props.campaign.details ||
      !this.props.user
    ) {
      return null;
    }
    var total = this.props.campaign.amount
      ? this.props.campaign.amount
      : os.getTotalPrice(this.props.campaign, this.props.products);

    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Underlag">
          <Row>
          <p>För att kunna räkna ut nyckeltal för din kampanj behöver du komplettera med viss information. Genom att fylla i de intäkter som kommit från kampanjen och antalet sålda enheter så räknas avkastning på investering/ROI fram för kampanjen. </p>
          </Row>
          <Row>
            <Field  
                ref="revenue"
                value={this.props.campaign.details.revenue}
                floatingLabelText="Intäkter (SEK)"
            />
          </Row> 
  
          <Row>
            <Field  
                ref="units_sold"
                value={this.props.campaign.details.units_sold}
                floatingLabelText="Antal sålda enheter"
            />
          </Row> 

          <Row> 
            <RaisedButton
                    onTouchTap={this.handleFormSubmit.bind(this)}
                    primary={true}
                    label="Spara"
                  />
          </Row> 

        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Rapporter" to="/rapporter" />
          <span className="pathsep" />
          <MenuLink
            label={this.props.campaign.details.name}
            to={this.props.params.id}
          />
        </Subheader>

        {this.renderBookings()}
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  if (
    !state.campaigns.list.data ||
    !state.brands.list.data ||
    !state.auth.user
  ) {
    return { pending: true };
  }
  return {
    campaign: state.campaigns.list.data[ownProps.params.id],
    user: ownProps.user,
    products: state.products.list.data,
    brands: state.brands.list.data,
    pending: state.campaigns.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...products, ...campaigns, ...brands },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(Report);



// WEBPACK FOOTER //
// ./src/pages/campaigns/Report.jsx